function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLeaf(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "4.5179mm",
    height: "4.2968mm",
    viewBox: "0 0 49 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#fff"
    },
    fillRule: "evenodd",
    d: "M49 42c-4,-1 -7,-3 -9,-5 1,-4 2,-8 1,-11 -1,-5 -5,-9 -9,-12 -5,-3 -9,-4 -13,-5 -2,0 -4,0 -7,-1 -4,-1 -9,-6 -9,-6l-3 -2 0 4c0,0 0,6 2,15 1,10 5,17 10,21 4,4 9,6 14,6 5,-1 9,-3 11,-6 3,2 6,4 10,5 1,-1 2,-2 2,-3zm-13 -7c-6,-10 -19,-16 -29,-24 11,13 22,14 29,24z"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeaf);
export default __webpack_public_path__ + "static/media/leaf.065d83a586580d2188f5e1075f0ca9e3.svg";
export { ForwardRef as ReactComponent };